import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchCounsellors } from "./helpAndAssistantApi";

interface MyKnownError {
  errorMessage: string
  // ...
}

export interface CounsellorAttributes {

  id: string
  employeeId: number
  name : string
  location:string
  sector: string
  unit:string
  designation: string
  emailId : string
  createdDate: string
  updatedBy : string
  updatedDate: string
  status: string

}
export interface CounsellorModel {
  companyGroup: string
  ethicsCounsellorsLists: Array<CounsellorAttributes>
}

export interface CounsellorsState {
  counsellors: Array<CounsellorModel>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: CounsellorsState = {
  counsellors: [],
  status: "idle",
};

export const GetCounsellors = createAsyncThunk(
  "Counsellors/fetch",
  async (data:any) => {
    const response = await fetchCounsellors(data);
    return response;
  }
);

export const CounsellorsSlice = createSlice({
  name: "Counsellors",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetCounsellors.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetCounsellors.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetCounsellors.fulfilled, (state, action) => {
        state.status = "idle";
        state.counsellors = action?.payload.ethicscounsellor;
     //    state.companyList = action?.payload?.map((a :any) =>  return a?.companyGroup as []);
     //    state.counsellors = action?.payload?.map((a :any) => a?.ethicsCounsellorsLists as []);
      });
  },
});

export const {} = CounsellorsSlice.actions;

// export const selectCompanyList = (state: RootState) => {
//   return state.CounsellorReducer.companyList;
// };

export const selectCounsellors = (state: RootState) => {
     return state.CounsellorReducer.counsellors;
};
export default CounsellorsSlice.reducer;
